import React, { useContext, useEffect, useState } from "react";
import { Context } from "context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import {
  faTrash,
  faSearch,
  faEraser,
  faUserPen,
} from "@fortawesome/free-solid-svg-icons";
import "./styles.scss";

import { Col, Form, Row, Table, Badge } from "react-bootstrap";

import Button from "components/_base/Button";
import ModalConfirmarDelete from "components/ModalConfirmarDelete";
import TablePagination from "components/TablePagination";

import { GET_LIST_USUARIO } from "services/Usuario";

const ContentUsuario = () => {
  const { showLoader } = useContext(Context);
  const navigate = useNavigate();

  const options = [
    {
      label: "Selecione",
      value: "",
    },
    {
      label: "Ativo",
      value: "true",
    },
    {
      label: "Inativo",
      value: "false",
    },
  ];

  const valorInicial = {
    usuarioId: 0,
    nome: "",
    email: "",
    phoneNumber: "",
    ativo: "",
    PageSize: 25,
    PageNumber: 1,
  };

  const [pageData, setPageData] = useState({
    totalRows: 0,
    totalPages: 0,
  });
  const [usuarios, setUsuarios] = useState({});
  const [filtro, setFiltro] = useState(valorInicial)
  const [pageCurrent, setPageCurrent] = useState(1);
  // const handleDelete = async (questaoId) => {
  //   showLoader(true);
  //   // await DELETE_QUESTAO(questaoId);

  //   // setQuestaoToDelete(null);
  //   // setShowModal(false);
  //   // window.location.reload();

  //   showLoader(false);
  // };

  useEffect(() => {
    if (filtro.PageNumber !== pageCurrent) {
      handleSaveFilter();
      setPageCurrent(filtro.PageNumber);  // Atualiza o controle da página atual
    }
  }, [filtro.PageNumber]); // O useEffect será acionado sempre que filtro.PageNumber mudar

  const handleUpdateUsuario = (usuarioId) => {
    navigate(`editar?id=${usuarioId}`);
  };

  const handleFiltroChange = async (e) => {
    const { name, value } = e.target;
    setFiltro({
      ...filtro,
      [name]: value ? value : "",
    });
  };

  const handleChangePageNumber = (pageNumber) => {
    setFiltro({
      ...filtro,
      PageNumber: pageNumber,
    });
  };

  const handleClearFilter = () => {
    setFiltro(valorInicial);
    setPageData({
      totalRows: 0,
      totalPages: 0,
    });

    window.location.reload();
  };

  const handleSaveFilter = async (e) => {
    showLoader(true);
    const params = {
      ...filtro,
    };

    const data = await GET_LIST_USUARIO(params);
    setUsuarios(data.value.data);
    setPageData({
      totalRows: data.value.totalRows,
      totalPages: data.value.totalPages,
    });
    showLoader(false);
  };

  useEffect(() => {
    (async () => {
      showLoader(true);

      let params = {
        ...filtro,
      };

      const data = await GET_LIST_USUARIO(params);
      setUsuarios(data.value.data);
      setPageData({
        totalRows: data.value.totalRows,
        totalPages: data.value.totalPages,
      });
      showLoader(false);
    })();
  }, []);

  return (
    <React.Fragment>
      {/* <ModalConfirmarDelete
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setQuestaoToDelete(null);
        }}
        handleDelete={() => handleDelete(questaoToDelete)}
      /> */}
      <div className="admin-usuario-container">
        <div className="admin-header">
          <h1>Usuários</h1>
        </div>
        <hr />
        <div className="admin-usuario-content-wrapper">
          <div className="admin-usuario-content">
            <Form className="responsive ms-3 p-2">
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className="mb-3">
                    Nome
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="nome"
                    type="text"
                    onChange={handleFiltroChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className=" mb-3">
                    Email
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="email"
                    type="text"
                    onChange={handleFiltroChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className="mb-3">
                    Situação
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Select
                    name="ativo"
                    value={
                      options.find(
                        (option) => option.value === filtro.ativo.toString()
                      )?.value || ""
                    }
                    onChange={handleFiltroChange}
                  >
                    {options.map((option) => (
                      <option
                        key={option.value}
                        value={option.value.toString()}
                      >
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="2"></Col>
                <Col sm="8" className="d-flex justify-content-start">
                  <Button
                    className="btn-filtro-usuario me-3"
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSaveFilter();
                    }}
                  >
                    <FontAwesomeIcon icon={faSearch} className="btn-icon" />
                    Filtrar
                  </Button>
                  <Button
                    className="btn-filtro-usuario "
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClearFilter();
                    }}
                  >
                    <FontAwesomeIcon icon={faEraser} className="btn-icon" />
                    Limpar filtro
                  </Button>
                </Col>
              </Form.Group>
            </Form>
            <hr />
            <Table responsive="sm" bsPrefix="usuario-table">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Telefone</th>
                  <th>Tipo de usuario</th>
                  <th>Situação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.length > 0 ? (
                  usuarios.map((usuario) => (
                    <tr key={usuario.usuarioId + 1}>
                      <td>{usuario.usuarioId}</td>
                      <td>{usuario.nome}</td>
                      <td>
                        {!usuario.email ? (
                          <Badge bg="danger">Sem email cadastrado</Badge>
                        ) : (
                          usuario.email
                        )}
                      </td>
                      <td>{usuario.phoneNumber || "-"}</td>
                      <td>{usuario.usuarioTipo}</td>
                      <td>{usuario.ativo ? <>Ativo</> : <>Inativo</>}</td>
                      <td>
                        <div className="btns-container">
                          <Button
                            className="btn-usuario"
                            onClick={(e) => {
                              e.preventDefault();
                              handleUpdateUsuario(usuario.usuarioId);
                            }}
                          >
                            <FontAwesomeIcon icon={faUserPen} size="xs" />
                            {""}
                          </Button>
                          {/* <Button
                            className="btn-questao"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDeleteModal(usuario.id);
                            }}
                          >
                            <FontAwesomeIcon icon={faUserPen} size="xs" />
                            {""}
                          </Button> */}
                          {/* <Button
                            className="btn-questao"
                            // onClick={() => handleEdit(questao)}
                          >
                            <FontAwesomeIcon icon={faEdit} size="xs" />
                            {""}
                          </Button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Nenhuma usuário encontrado
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <hr />
            <div className="pagination">
              <TablePagination
                pageNumber={filtro.PageNumber}
                setPageNumber={handleChangePageNumber}
                totalPages={pageData.totalPages}
                totalRows={pageData.totalRows}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentUsuario;
